import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router';
import './tableau-dashboard-styles.scss';
import { ApiEndpoints, Constants } from '../../constants/appConstants';
import httpService from '../../services/httpService';
import { ProjectConfiguration } from '../P4P/ProviderProfile/models';
import { useAppContext } from '../../Context';
import ComingSoon from '../../pages/ComingSoon';

const TableauDashboardComponent: React.FC = () => {
    const [projectConfiguration, setProjectConfiguration] = useState<ProjectConfiguration | null>(null);
    const [tableauCdnJsUrl, setTableauCdnJsUrl] = useState<string>();
    const [dashboardType, setDashboardType] = useState<string>('');
    const [showComingSoon, setShowComingSoon] = useState<boolean>(false);
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const { providerType } = useAppContext();
    const portalQuery = searchParams.get('portal');

    useEffect(() => {
        const portal = portalQuery ?? location.state?.portal;
        const isP4P = portal === Constants.P4P_TABLEAU_URL_KEY;

        if (isP4P) {
            if (providerType === Constants.RSKey) {
                setShowComingSoon(true);
                setDashboardType('');
                return;
            }
            setShowComingSoon(false);
            setDashboardType(Constants.P4P_TABLEAU_URL_KEY);
        } else {
            setShowComingSoon(false);
            if (providerType === Constants.SCOKey) {
                setDashboardType(Constants.PBC_TABLEAU_URL_KEY);
            } else if (providerType === Constants.RSKey) {
                setDashboardType(Constants.PBC_RS_TABLEAU_URL_KEY);
            } else {
                setDashboardType('');
            }
        }
    }, [portalQuery, location.state?.portal, providerType]);

    useEffect(() => {
        let active = true;
        setProjectConfiguration(null);
        setTableauCdnJsUrl(undefined);

        const loadConfiguration = async () => {
            try {
                const response = await httpService.get<{ configValue: string }>(`${ApiEndpoints.GetProjectConfigurationDetailsByKey}/${Constants.TABLEAU_CDN_JS_URL_KEY}`);
                if (active) {
                    setTableauCdnJsUrl(response.data.configValue);
                }
            } catch (error: unknown) {
                console.error('TableauDashboardComponent.loadConfiguration: Failed to retrieve Tableau CDN configuration', error);
            }

            if (dashboardType) {
                try {
                    const response = await httpService.get<ProjectConfiguration>(`${ApiEndpoints.GetProjectConfigurationDetailsByKey}/${dashboardType}`);
                    if (active) {
                        setProjectConfiguration(response.data);
                    }
                } catch (error: unknown) {
                    console.error('TableauDashboardComponent.loadConfiguration: Failed to retrieve dashboard configuration', error);
                }
            }
        };

        void loadConfiguration();
        return () => {
            active = false;
        };
    }, [dashboardType]);

    return (
        <div className="tableau-dashboard-container">
            {showComingSoon ? (
                <ComingSoon />
            ) : (
                tableauCdnJsUrl && projectConfiguration && projectConfiguration.configValue && (
                    <>
                        <iframe
                            src={`${projectConfiguration.configValue}?:embed=y&:tabs=no&:toolbar=no&:showAppBanner=false&:showShareOptions=true&:display_count=no&:showVizHome=no&:origin=viz_share_link`}
                            title="Executive Dashboard"
                            allowFullScreen
                        />
                        <script type="module" src={tableauCdnJsUrl}></script>
                    </>
                )
            )}
        </div>
    );
};

export default TableauDashboardComponent;
